import { NbJSThemeOptions } from '@nebular/theme';
import { DEFAULT_THEME } from './theme.default';

export const UTUM_EIT_THEME = {
  name: 'utum-eit_default',
  base: 'default',
  // We could override this in the future
  variables: DEFAULT_THEME.variables,
} as NbJSThemeOptions;
